// extracted by mini-css-extract-plugin
export default {"title":"TVShowDetail_title__FeE3F","rating":"TVShowDetail_rating__OLHhC","rating_contianer":"TVShowDetail_rating_contianer__OW97W","overview":"TVShowDetail_overview__l23Nc"};